import type { Metadata } from '@vp/ubik-fragment-types'

export const getPageTitle = (locale: string): string => {
  switch (locale) {
    case 'en-us':
    case 'en-gb':
    case 'en-ca':
    case 'en-au':
    case 'en-in':
    case 'en-ie':
    case 'en-nz':
    default:
      return 'Contact Us - VistaPrint Help Centre'
  }
}

export const contactUsMetadata = (): Metadata[] => {
  return [
    {
      attributes: [
        {
          name: 'robots',
          content: 'noindex, nofollow',
        },
      ],
    },
    {
      attributes: [
        {
          name: 'pageName',
          content: `Contact Us`,
        },
      ],
    },
    {
      attributes: [
        {
          name: 'pageStage',
          content: 'Customer Care',
        },
      ],
    },
    {
      attributes: [
        {
          name: 'pageSection',
          content: 'Help Center:Contact Us',
        },
      ],
    },
    {
      attributes: [
        {
          name: 'category',
          content: 'Help Center - Contact Us',
        },
      ],
    },
  ]
}
